<script>
import LoginPage from '@/components/LoginPage.vue'
import LandingPage from '@/components/LandingPage.vue'
import VersionCheckPage from '@/components/VersionCheckPage.vue'

export default {
  inject: ['$_'],
  props: {
    registryStatus: Boolean,
    onlineStatus: Boolean,
    appUpdatingStatus: Boolean,
    appUpdatedStatus: Boolean,
    appVersionNumber: String,
    registeredStatus: Boolean,
    updateAvailableStatus: Boolean,
    refreshForUpdate: Boolean,
    dbName: {type: String, default: 'default-dbname'},
    dbVersion: {type: String, default: '1'}
  },
  data() {
    return {
      showVersionCheck: true,
      showLogin: false,
      showProfile: false,
      loginMsgText: '',
      registerSuccessText: '',
      registerFailText: '',
      reminderSuccessText: '',
      reminderFailText: '',
      loginData: {},
      signInState: true,
      registerState: false,
      db: null,
      ready: false,
      addDisabled: false,
      forgotPassState: false,
      IDB: false
    }
  },
  name: 'ProfileView',
  components: {
    LoginPage,
    LandingPage,
    VersionCheckPage
  },
  methods: {
    logoutEmission() {
      let vm = this;
      vm.clearAllDbStores(vm.IDB);
      localStorage.clear();
      location.reload();
    },
    resetPageEmission(resetPageEmissions) {
      let vm = this;
      switch (resetPageEmissions.signInState) {
        case 'createAccount':
          vm.signInState = false;
          vm.registerState = true;
          vm.forgotPassState = false;
          vm.loginMsgText = '';
          vm.registerSuccessText = '';
          vm.registerFailText = '';
          break;
        case 'signIn':
          vm.signInState = true;
          vm.registerState = false;
          vm.forgotPassState = false;
          vm.loginMsgText = '';
          vm.registerSuccessText = '';
          vm.registerFailText = '';
          break;
        case 'forgotPassword':
          vm.signInState = false;
          vm.registerState = false;
          vm.forgotPassState = true;
          vm.loginMsgText = '';
          vm.registerSuccessText = '';
          vm.registerFailText = '';
          vm.loginMsgText = '';
          vm.registerSuccessText = '';
          vm.registerFailText = '';
          break;
      }

    },
    loginEmission(loginEmissions) {
      let vm = this;
      if (loginEmissions.status) {
        vm.showProfile = true;
        vm.showLogin = false;
        vm.registerState = false;
        vm.loginData = loginEmissions.loginData
      } else {
        vm.loginMsgText = loginEmissions.reason
      }
    },
    passwordResetEmission(loginEmissions) {
      let vm = this;
      vm.signInState = false;
      vm.loginMsgText = '';
      vm.registerSuccessText = '';
      vm.registerFailText = '';
      vm.loginMsgText = '';
      vm.registerSuccessText = '';
      vm.registerFailText = '';
      vm.forgotPassState = true;
      if (loginEmissions.status) {
        vm.reminderFailText = '';
        vm.reminderSuccessText = loginEmissions.reminderData;
      } else {
        vm.reminderSuccessText = '';
        vm.reminderFailText = loginEmissions.reason;
      }
    },
    registryEmission(registryEmissions) {
      let vm = this;
      if (registryEmissions.status) {
        vm.signInState = false;
        vm.registerFailText = '';
        vm.registerSuccessText = registryEmissions.registrationData;
      } else {
        vm.signInState = false;
        vm.registerSuccessText = '';
        vm.registerFailText = registryEmissions.reason;
      }
    },
    goToNextPage() {
      let vm = this;
      const storedAccount = localStorage.getItem("account");
      vm.showVersionCheck = false;
      if (storedAccount) {
        vm.loginData = JSON.parse(storedAccount);
        vm.showLogin = false;
        vm.registerState = false;
        vm.showProfile = true;
      } else {
        vm.showLogin = true;
        vm.registerState = false;
        vm.showProfile = false;
      }
    }
  },
  async mounted() {
    let vm = this;
    vm.IDB = await vm.getIDB()
    vm.ready = true;
    window.addEventListener('offline', () => {
      vm.onlineStatus = false;
    });
    window.addEventListener('online', () => {
      vm.onlineStatus = true;
    });
  }
}
</script>

<template>
  <div class="home">

    <VersionCheckPage v-if="showVersionCheck"
                      v-bind:appVersionNumber="appVersionNumber"
                      v-on:versionIsUpToDate="goToNextPage"/>
    <LandingPage v-if="showProfile"
                 v-bind:loginData="loginData"
                 v-on:logoutEmission="logoutEmission"/>
    <LoginPage v-if="showLogin"
               v-bind:signIn="signInState"
               v-bind:forgotPass="forgotPassState"
               v-bind:register="registerState"
               v-bind:loginMsg="loginMsgText"
               v-bind:registerSuccessMsg="registerSuccessText"
               v-bind:registerFailMsg="registerFailText"
               v-bind:onlineStatus="onlineStatus"
               v-bind:registryStatus="registryStatus"
               v-bind:appVersionNumber="appVersionNumber"
               v-bind:appUpdatingStatus="appUpdatingStatus"
               v-bind:appUpdatedStatus="appUpdatedStatus"
               v-bind:reminderSuccessMsg="reminderSuccessText"
               v-bind:reminderFailMsg="reminderFailText"
               v-on:resetPageEmission="resetPageEmission"
               v-on:registerEmission="registerEmission"
               v-on:loginEmission="loginEmission"
               v-on:passwordResetEmission="passwordResetEmission"
               v-on:registryEmission="registryEmission"/>

  </div>
</template>

<style>
html {
  background-image: url("../assets/img/surgeons photo1.png");
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: sans-serif;
}
</style>
